import { Typography as NovaTypography, TypographyProps as NovaTypographyProps } from '@fme-nova/components'
import { Typography as MuiTypographyBase, TypographyProps as MuiTypographyProps } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'

export const Typography = createComponentWrapperWithRef<MuiTypographyProps | NovaTypographyProps>(
  {
    mui: MuiTypographyBase,
    nova: NovaTypography,
    propsEnhancer(props) {
      if (props.variant === 'h6') {
        props.component ??= 'span'
      }
      return props
    },
  },
  'Typography',
)

export type TypographyProps = MuiTypographyProps
